import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalenderCheck = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M7.84459 4.97458L8.69059 5.82538L5.48779 9.00958L3.77299 7.26478L4.62739 6.42178L5.49619 7.30978L7.84459 4.97458Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8.39995 1.19998H9.39235C10.1874 1.21558 10.8 1.82998 10.8 2.59798V9.39717C10.8 10.1838 10.182 10.8 9.39235 10.8H2.60755C1.81795 10.8 1.19995 10.1838 1.19995 9.39717V2.59798C1.19995 1.82998 1.81255 1.21558 2.59495 1.19998H3.59995V0.599976H4.79995V1.19998H7.19995V0.599976H8.39995V1.19998ZM2.39995 3.59998H9.59995V2.59798C9.59995 2.48938 9.50335 2.40238 9.38035 2.39998H8.39995V2.99998H7.19995V2.39998H4.79995V2.99998H3.59995V2.39998H2.60755C2.49655 2.40238 2.39995 2.48938 2.39995 2.59798V3.59998ZM9.39235 9.59997C9.51235 9.59997 9.59995 9.51478 9.59995 9.39717V4.79998H2.39995V9.39717C2.39995 9.51478 2.48755 9.59997 2.60755 9.59997H9.39235Z",
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgCalenderCheck);
export { ForwardRef as ReactComponent };
